import dynamic from 'next/dynamic';

import { useListing } from '@/hooks/queries/useListing';

const DevelopmentTitle = dynamic(() =>
  import('@/components/property-expose/DevelopmentTitle/DevelopmentTitle').then((mod) => mod.DevelopmentTitle),
);

export const DynamicDevelopmentTitle = () => {
  const {
    data: { listing },
  } = useListing();

  if (!listing) return null;

  return <DevelopmentTitle listing={listing} />;
};
